<template>
    <div class="dialog-screen">
        <div class="table-layout">
            <el-table class="thin" :data="pageDevcCatImpInfoList" ref="deviceImpInfoTable" border :row-key="rowItemKey" @selection-change="handleSelectionChange" style="width: 100%; font-size: 12px">
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column label="行号" width="60" align="center" type="index" :index="getRowNo"></el-table-column>
                <el-table-column label="级别" prop="level" width="80">
                    <template slot-scope="rows">
                        <input :disabled="rows.row.execState == 2" type="text" style="width:60px" v-model="rows.row.level"/>
                    </template>
                </el-table-column>

                <el-table-column label="名称" prop="catName" width="140">
                    <template slot-scope="rows">
                        <input :disabled="rows.row.execState == 2" type="text" style="width:110px" v-model="rows.row.catName"/>
                    </template>
                </el-table-column>
                <el-table-column label="编码" prop="catCode" width="140">
                    <template slot-scope="rows">
                        <input :disabled="rows.row.execState == 2" type="text" style="width:110px" v-model="rows.row.catCode"/>
                    </template>
                </el-table-column>
                <el-table-column label="上级编码" prop="parentCode" width="140">
                    <template slot-scope="rows">
                        <input :disabled="rows.row.execState == 2" type="text" style="width:110px" v-model="rows.row.parentCode"/>
                    </template>
                </el-table-column>
                <el-table-column label="验收自动入账" prop="fiscalAcctAutoIn" width="100">
                    <template slot-scope="rows">
                        <input :disabled="rows.row.execState == 2" type="checkbox" v-model="rows.row.fiscalAcctAutoIn"/>
                    </template>
                </el-table-column>
                <el-table-column label="使用年限(月)" prop="durableLife" width="100">
                    <template slot-scope="rows">
                        <input :disabled="rows.row.execState == 2" type="number" style="width:80px" v-model="rows.row.durableLife"/>
                    </template>
                </el-table-column>
                <el-table-column label="需要供应商提供唯一标识码" prop="vendorUknoFlag" width="160">
                    <template slot-scope="rows">
                        <input :disabled="rows.row.execState == 2" type="checkbox" v-model="rows.row.vendorUknoFlag"/>
                    </template>
                </el-table-column>
                <el-table-column label="校验结果" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span class="stateinfo">
                            <i v-if="rows.row.checkState == 1" class="icon iconfont icon-success small font-green"></i>
                            <!--<i v-if="rows.row.checkState == -1" class="icon iconfont icon-error small font-red"></i>-->
                        </span>
                        <span v-if="rows.row.checkState <0" class="font-red">{{rows.row.checkMsg}}</span>
                        <!--<template v-if="rows.row.checkState <0" >-->
                        <!--<span slot="content" style="white-space: pre-wrap" v-html="rows.row.checkMsg"></span>-->
                        <!--<span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>-->
                        <!--</template>-->
                    </template>
                </el-table-column>
                <el-table-column label="执行结果" width="120" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span class="stateinfo">
                            <img v-show="rows.row.execState == 1" class="icon-loading" v-resc-url="'/image/loading.gif'"/>
                            <i v-show="rows.row.execState == 2" class="icon iconfont icon-success small font-green"></i>
                            <!--<i v-show="rows.row.execState == -1" class="icon iconfont icon-error small font-red"></i>-->
                        </span>
                        <span v-if="rows.row.execState <0" class="font-red">{{rows.row.execMsg}}</span>
                    </template>
                </el-table-column>

            </el-table>
        </div>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10 " @click="execItemImport">执行导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="checkItems">校验检查</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="sortItemRows">条目排序</div>
        </div>

    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes, VRowId} from '../../app.vues'
    import {getMerchantBizParam} from '../asset/assetMain';

    import {getDefaultPageSizes} from '../../../src/app.conf'
    import shopDevcApi from '../../api/shopDevc'

    export default {
        name: 'swb-devc-cat-imp-check',
        desc: '',
        props: ['fileObj'],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: 10,
                pageSizes: getDefaultPageSizes(),
                pageDevcCatImpInfoList: [],
                devcCatImpDto: {
                    retailerId: null,
                    originalFileName: null,
                    devcCatImpInfoList: []
                },
                isOk: false,
                theLoading: null,
                checkPassed: false,
                nextIndex: 0,
                importFlag: false,
                //
                stopFlag: true,
                //
                rowItemKey: 'vRowId',
                vRowIdList: [],
                multipleSelection: []
            }
        },
        created: function () {
            this.theVRowId = VRowId.newOne().name(this.rowItemKey);
            //
            this.pageSize = this.pageSizes.first();
            //
            this.devcCatImpDto.originalFileName = this.fileObj.extra.originalFileName;
            let devcCatImpInfoList = this.fileObj.extra.devcCatImpInfoList;
            devcCatImpInfoList.forEach(function (item) {
                item.checkState = 0;
                item.execState = 0;
            });
            this.theVRowId.setIds(devcCatImpInfoList);
            this.devcCatImpDto.devcCatImpInfoList = devcCatImpInfoList;
            //
            this.checkItems();
        },
        mounted() {

        },
        destroyed() {
            this.fileObj = null;
            //
            this.theVRowId = null;
        },
        methods: {
            getRowNo(rowIndex) {
                let baseCount = (this.pageNumber - 1) * this.pageSize;
                return baseCount + rowIndex + 1;
            },
            getDlgResult: function () {
                return this.devcCatImpDto;
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageDevcCatImpInfoList();
            },
            setPageDevcCatImpInfoList: function () {
                let totalRows = this.devcCatImpDto.devcCatImpInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                let rows = totalRows.slice(start, end);
                this.pageDevcCatImpInfoList = rows;
                this.totalCount = totalRows.length;
            },
            // 排序
            sortItemRows: function () {
                let devcCatImpInfoList = this.devcCatImpDto.devcCatImpInfoList;
                // 先按照级别排序最后按照上级编码排序
                devcCatImpInfoList = devcCatImpInfoList.sort(function (devcCat1, devcCat2) {
                    if (devcCat1.level < devcCat2.level) {
                        return -1;
                    }
                    else if (devcCat1.level > devcCat2.level) {
                        return 1;
                    }
                    //
                    if (devcCat1.parentCode < devcCat2.parentCode) {
                        return -1;
                    }
                    if (devcCat1.parentCode > devcCat2.parentCode) {
                        return 1;
                    }
                    //
                    if (devcCat1.catCode < devcCat2.catCode) {
                        return -1;
                    }
                    if (devcCat1.catCode > devcCat2.catCode) {
                        return 1;
                    }
                    return 0;
                });
                //
                this.devcCatImpDto.devcCatImpInfoList = devcCatImpInfoList;
                this.setPageDevcCatImpInfoList();
            },
            checkItemRows: function (rowIndex) {
                let devcCatImpInfoList = this.devcCatImpDto.devcCatImpInfoList;
                //
                let catCodeSeqNoMap = {};
                // 校验是否有级别，是否有编码，大于1级时是否有上级编码.
                let checkMap = {};
                //
                for (let i = 0, count = devcCatImpInfoList.length; i < count; i++) {
                    let devcCatImpInfo = devcCatImpInfoList[i];
                    let execState = devcCatImpInfo.execState;
                    if (execState <= 0) {
                        devcCatImpInfo.checkState = 0;
                        //
                        devcCatImpInfo.checkMsg = null;
                        devcCatImpInfo.execMsg = null;
                        //
                        let errMsgs = [];
                        let catCode = devcCatImpInfo.catCode;
                        if (!Utils.isNoB(catCode)) {
                            let prevSeqNo = catCodeSeqNoMap[catCode];
                            if (prevSeqNo != null) {
                                errMsgs.push('编码与 ' + (prevSeqNo) + '行的编码重复');
                            } else {
                                catCodeSeqNoMap[catCode] = i + 1;
                            }
                        }
                        // 使用年限
                        if (!Utils.isNoB(devcCatImpInfo.durableLife)) {
                            if (devcCatImpInfo.assetNature == 2) {
                                if (!Utils.isNaturalStr(devcCatImpInfo.durableLife)) {
                                    errMsgs.push("使用年限必须为大于等于0的整数");
                                }
                            } else {
                                if (!Utils.isNaturalStr(devcCatImpInfo.durableLife, true)) {
                                    errMsgs.push("使用年限必须为大于0的整数");
                                }
                            }
                        } else {
                            errMsgs.push("使用年限不可为空");
                        }
                        if (errMsgs.length > 0) {
                            devcCatImpInfo.checkMsg = errMsgs.join("\n");
                            devcCatImpInfo.checkState = -1;
                        }
                        else {
                            devcCatImpInfo.checkState = 1;
                        }
                        //
                        devcCatImpInfo.execState = 0;
                    }
                }
                this.devcCatImpDto.devcCatImpInfoList = Utils.merge([], devcCatImpInfoList);
                this.setPageDevcCatImpInfoList();
                this.checkPassed = true;

            },
            checkItems: function () {
                let self = this;
                this.checkItemRows();
                //
                let devcCatImpDto = this.devcCatImpDto || {};
                let devcCatImpInfoList = devcCatImpDto.devcCatImpInfoList || [];
                for (let i = 0; i < devcCatImpInfoList.length; i++) {
                    let devcCatImpInfo = devcCatImpInfoList[i];
                    this.doCheckDevcCat(devcCatImpInfo, function (resultInfo) {
                        // 重新设置后台返回的数据。
                        devcCatImpInfo.assetKindId = resultInfo.assetKindId || null;
                        devcCatImpInfo.assetKindName = resultInfo.assetKindName || null;
                        //
                        if (resultInfo.errorMsg != null) {
                            devcCatImpInfo.checkState = -1;
                            devcCatImpInfo.checkMsg = resultInfo.errorMsg;
                        }
                        self.$set(devcCatImpInfoList, i, devcCatImpInfo);
                        //
                        devcCatImpDto.devcCatImpInfoList = Utils.merge([], devcCatImpInfoList);
                        self.devcCatImpDto = Utils.merge({}, devcCatImpDto);
                        //
                        self.setPageDevcCatImpInfoList();
                    });
                }
            },
            execItemImport: function () {
                //先排序（保證關係）
                this.sortItemRows();
                //
                this.checkItemRows();
                if (Utils.isTrue(this.checkPassed)) {
                    this.doItemImport();
                }
                this.doItemImport(null);
            },
            doCheckDevcCat: function (devcCatImpInfo, callBack) {
                let theLoading = MsgBox.loading();
                shopDevcApi.doCheckDevcCat(devcCatImpInfo, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        callBack(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            doItemImport: function (prevRowId) {
                let self = this;
                //
                let devcCatImpInfoList = this.devcCatImpDto.devcCatImpInfoList;
                let prevIndex = -1;
                if (prevRowId != null) {//首次執行
                    prevIndex = devcCatImpInfoList.indexOf(null, function (item) {
                        return item[self.rowItemKey] == prevRowId;
                    });
                }
                //找到下一個

                let nextIndex = devcCatImpInfoList.indexOf(null, prevIndex + 1, function (item) {
                    return item.execState <= 0 && item.checkState == 1;
                });

                if (nextIndex < 0) {
                    //
                    let allDone = devcCatImpInfoList.every(function (item) {
                        return item.execState == 2;
                    });
                    if (allDone) {
                        self.$emit('other-close');
                    }
                    //
                    return;
                }
                //
                let devcCatImpInfo = devcCatImpInfoList[nextIndex];
                let vRowId = devcCatImpInfo[self.rowItemKey];
                //
                let nextPageNo = nextIndex / this.pageSize;
                let theLoading = MsgBox.loading("总第 " + (nextIndex + 1) + " 行数据...");
                devcCatImpInfo.execState = 1;//
                this.$set(devcCatImpInfoList, nextIndex, devcCatImpInfo);
                shopDevcApi.doImportDevcCat(devcCatImpInfo, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let execMsg = result.data;
                        if (Utils.isNoB(execMsg)) {
                            devcCatImpInfo.execState = 2;
                            devcCatImpInfo.execMsg = null;
                        }
                        else {
                            devcCatImpInfo.execState = -1;
                            devcCatImpInfo.execMsg = execMsg;
                        }
                    }
                    else {
                        devcCatImpInfo.execState = -1;
                        devcCatImpInfo.execMsg = result.message;
                        //
                        MsgBox.warning(result.message);
                    }
                    //
                    self.$set(devcCatImpInfoList, nextIndex, devcCatImpInfo);
                    //
                    self.doItemImport(vRowId);
                });

            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/DevcCatImpCheck.vue